<template>
    <div>
        <div class="row">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-lg-12">
                    <div class="form-group">
                        <label>Text</label>
                        <textarea
                            class="form-control"
                            placeholder="Type your text here, be nice!"
                            :cols="30"
                            :rows="6"
                            :maxlength="160"
                            @input="onTextInput"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Width</label>
                        <input
                            type="number"
                            class="form-control"
                            :value="params.width"
                            @input="onWidthInput"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Height</label>
                        <input
                            type="number"
                            class="form-control"
                            :value="params.height"
                            @input="onHeightInput"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <span
                            ref="sizeError"
                            class="error-block"
                        ></span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Font Family</label>
                        <select
                            class="form-control"
                            @change="onFontFamilyChange"
                        >
                            <option
                                v-for="(font, idx) in fonts"
                                :key="idx"
                                :value="font"
                            >
                                {{ font }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Font Size</label>
                        <input
                            type="number"
                            class="form-control"
                            :value="params.fontSize"
                            @input="onFontSizeInput"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Background Color</label>
                        <verte
                            :value="params.backgroundColor"
                            menuPosition="left"
                            model="hex"
                            @input="onBackGroundColorInput"
                        ></verte>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Text Color</label>
                        <verte
                            :value="params.textColor"
                            menuPosition="right"
                            model="hex"
                            @input="onTextColorInput"
                        ></verte>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Text align</label>
                        <select
                            class="form-control"
                            @change="onTextAlignInput"
                        >
                            <option
                                v-for="(value, idx) in textAlign"
                                :key="idx"
                                :value="value"
                            >
                                {{ value }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Padding Top</label>
                        <input
                            type="number"
                            class="form-control"
                            :value="params.paddingTop"
                            @input="onPaddingTopInput"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Image Name</label>
                        <input
                            type="text"
                            class="form-control"
                            :value="params.imageName"
                            @input="onImageNameInput"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fonts, textAlign } from './data/styleData';
import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
    name: 'ImageParamsComponent',
    components: { Verte },
    data: function () {
        return {
            params: {
                text: '',
                width: 600,
                height: 600,
                fontFamily: 'Arial',
                fontSize: 24,
                backgroundColor: '#ffffff',
                textColor: '#000000',
                paddingTop: 10,
                textAlign: 'left',
                imageName: 'generated_mms_img',
                valid: false,
            },
            fonts,
            textAlign,
        };
    },
    mounted() {
        this.emitChanges();
    },
    methods: {
        onTextInput(event) {
            this.params.text = event.target.value;
            this.emitChanges();
        },
        onWidthInput(event) {
            this.params.width = event.target.value;
            this.emitChanges();
        },
        onHeightInput(event) {
            this.params.height = event.target.value;
            this.emitChanges();
        },
        onFontFamilyChange(event) {
            this.params.fontFamily = event.target.value;
            this.emitChanges();
        },
        onFontSizeInput(event) {
            this.params.fontSize = event.target.value;
            this.emitChanges();
        },
        onBackGroundColorInput(color) {
            this.params.backgroundColor = color;
            this.emitChanges();
        },
        onTextColorInput(color) {
            this.params.textColor = color;
            this.emitChanges();
        },
        onTextAlignInput(event) {
            this.params.textAlign = event.target.value;
            this.emitChanges();
        },
        onPaddingTopInput(event) {
            this.params.paddingTop = event.target.value;
            this.emitChanges();
        },
        onImageNameInput(event) {
            this.params.imageName = event.target.value || this.params.imageName;
            this.emitChanges();
        },
        emitChanges() {
            this.validate();
            this.$emit('paramsChanged', this.params);
        },
        validate() {
            const errorBlock = this.$refs.sizeError;
            const diff = +Math.abs(100 - (this.params.width / this.params.height) * 100).toFixed(10);

            if (diff > 30) {
                errorBlock.textContent = 'the difference between width and height should be less than 30%';
                errorBlock.style.display = 'block';
                this.params.valid = false;

                return false;
            } else {
                errorBlock.style.display = 'none';
                this.params.valid = true;

                return true;
            }
        },
    },
};
</script>

<style scoped>
.verte {
    justify-content: left;
}
.error-block {
    display: none;
    color: red;
    font-weight: bold;
}
</style>
